const { Table } = require("antd");

const CTable = (props) => {
  const {
    bordered,
    size,
    showSorterTooltip,
    sortDirections,
    pagination,
    ...restProps
  } = props;
  const pager = { ...pagination, hideOnSinglePage: true };
  return (
    <Table
      {...restProps}
      size={size || "small"}
      bordered={bordered || true}
      pagination={pager}
      showSorterTooltip={showSorterTooltip || false}
      sortDirections={sortDirections || ["ascend", "descend", "ascend"]}
    />
  );
};
export default CTable;
